import { kmlFileToGeoJSON, shpFilesToGeoJSON } from '@/utils/file-conversions'

export async function validatePerimetersFiles(files: File[]) {
  const possibleShpExtensions = ['shp', 'dbf', 'cpg', 'prj', 'shx']
  const possibleKmlExtensions = ['kml']

  const { shpFiles, kmlFile } = files.reduce(
    (acc, file) => {
      const fileExtension = file.name.split('.')[1]

      const isShp = possibleShpExtensions.some(
        (possibleExtension) => possibleExtension === fileExtension,
      )
      if (isShp) return { ...acc, shpFiles: [...acc.shpFiles, file] }

      const isKml = possibleKmlExtensions.some(
        (possibleExtension) => possibleExtension === fileExtension,
      )
      if (isKml) return { ...acc, kmlFile: file }

      return acc
    },
    {
      shpFiles: [] as File[],
      kmlFile: null as File | null,
    },
  )

  if (!shpFiles.length && !kmlFile) throw new Error('Perímetro inválido')

  if (
    shpFiles.length &&
    !possibleShpExtensions.every((ext) =>
      shpFiles.some((file) => file.name.includes(ext)),
    )
  )
    throw new Error('Está faltando arquivos!')

  const geojson = kmlFile
    ? await kmlFileToGeoJSON(kmlFile)
    : await shpFilesToGeoJSON(shpFiles)

  if (geojson instanceof Array) {
    throw new Error('Mais de um perímetro selecionado.')
  }

  return {
    geojson,
  }
}
